import CustomerIncidentReducer from "@common/redux/reducers/CustomerIncidentReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class CustomerIncidentAction extends BaseAction {}

const action = new CustomerIncidentAction(CustomerIncidentReducer);

export default action;
